module.exports = __webpack_public_path__ + "static/media/eye.26f924d1.svg";